import Cookies from 'js-cookie';

export const getMetaTrackingParams = (
  query: Record<string, string>
): { fbc?: string; fbp?: string } => {
  if (typeof window === 'undefined') return {};

  const fbp = Cookies.get('_fbp') || undefined;
  const fbcCookie = Cookies.get('_fbc');
  const fbc =
    fbcCookie ||
    (query.fbclid ? `fb.1.${Date.now()}.${query.fbclid}` : undefined);

  return {
    ...(fbc && { fbc }),
    ...(fbp && { fbp }),
  };
};
